export type DemandSourceType = "SqlRos" | "PoRelease" | "InventoryFlow";

export const DEMAND_SOURCE_OPTIONS: readonly {
  label: string;
  value: DemandSourceType;
}[] = [
  { label: "Inventory Flow (rate of sale)", value: "InventoryFlow" },
  { label: "Rate of sale (trailing SQL)", value: "SqlRos" },
  { label: "PO Release forecast (to arrival)", value: "PoRelease" },
];

export function demandSourceLabel(value: DemandSourceType): string {
  return (
    DEMAND_SOURCE_OPTIONS.find((option) => option.value === value)?.label ??
    value
  );
}

export function isDemandSourceType(value: string): value is DemandSourceType {
  return (
    value === "SqlRos" || value === "PoRelease" || value === "InventoryFlow"
  );
}

export function usesTrailingSqlRosWindow(value: DemandSourceType): boolean {
  return value === "SqlRos";
}
